/* eslint-disable react/prop-types */
import React, { createContext, useState, useMemo } from 'react';

const LoaderContext = createContext();
/* istanbul ignore next */
export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
/* istanbul ignore next */
  const handleChangeLoading = (stateLoading) => {
    setLoading(stateLoading);
  };

 /* istanbul ignore next */
  const data = useMemo(() => ({
    loading,
    handleChangeLoading,
  }), [loading]);

  return (
    <LoaderContext.Provider value={data}>
      {children}
    </LoaderContext.Provider>
  );
};

export default LoaderContext;